import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './BrandPlaceholder.module.css';

// Build up-to-2-letter initials from a brand name, e.g. "Bear Archery" -> "BA".
const initialsFromName = name => {
  const words = String(name || '')
    .replace(/[^a-zA-Z0-9 ]/g, ' ')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
};

/**
 * Fallback tile for brands that have no real logo in the archive.
 * Renders a camo-green badge with the brand initials, consistent with the
 * marketplace palette (--camoColor family).
 */
const BrandPlaceholder = props => {
  const { className, rootClassName, name } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <div className={classes} aria-label={name} title={name}>
      <span className={css.initials}>{initialsFromName(name)}</span>
    </div>
  );
};

BrandPlaceholder.defaultProps = {
  className: null,
  rootClassName: null,
  name: '',
};

BrandPlaceholder.propTypes = {
  className: string,
  rootClassName: string,
  name: string,
};

export default BrandPlaceholder;
